import { ArrowBendLeftUpIcon } from "@phosphor-icons/react/dist/ssr/ArrowBendLeftUp";
import { WarningCircleIcon } from "@phosphor-icons/react/dist/ssr/WarningCircle";

import type { TGalaxyError } from "@up/data";

function LocationsFromErrors(errors: Array<TGalaxyError>) {
  const formattedErrors = [];

  if (
    errors.some((e) => {
      return e.path[0] === "student";
    })
  ) {
    formattedErrors.push(
      <div key="student">
        <a className="flex items-center gap-1" href="#student-section">
          <ArrowBendLeftUpIcon size={20} />
          <span className="underline">Review Student information</span>
        </a>
      </div>,
    );
  }

  if (
    errors.some((e) => {
      return e.path[0] === "guardian";
    })
  ) {
    formattedErrors.push(
      <div key="guardian">
        <a className="flex items-center gap-1" href="#guardian-section">
          <ArrowBendLeftUpIcon size={20} />
          <span className="underline">Review Guardian information</span>
        </a>
      </div>,
    );
  }

  if (
    errors.some((e) => {
      return e.path[0] === "lineItems";
    })
  ) {
    formattedErrors.push(
      <div key="lineItems">
        <a className="flex items-center gap-1" href="#review-section">
          <ArrowBendLeftUpIcon size={20} />
          <span className="underline">Review courses</span>
        </a>
      </div>,
    );
  }

  return (
    <div>
      {formattedErrors.map((error) => {
        return error;
      })}
    </div>
  );
}

export const BlockingErrorsMessage = function BlockingErrorsMessage({
  errors,
}: {
  errors: Array<TGalaxyError> | undefined;
}) {
  const locations = errors?.length ? LocationsFromErrors(errors) : null;

  return (
    <div className="sticky block bottom-0 bg-white py-2 z-10 border-t border-gray-300">
      <span className="relative flex items-center gap-2 text-red-500 font-bold pt-1 pb-2 leading-none">
        <WarningCircleIcon size={20} weight="fill" className="block" />
        Your checkout contains errors
      </span>
      {locations ?? <div>Please review all information before proceeding.</div>}
    </div>
  );
};
